import React from "react";
import { ensure } from "sprint-common-web";

import { OrderAuditItem } from "../AuditItem";
import { renderSimpleChangeInfo } from "./renderAuditInfo";

export const FilenameChangeInfo: React.FunctionComponent<{ item: OrderAuditItem }> = (props: {
    item: OrderAuditItem;
}) => {
    const { item } = props;

    ensure(item.filename, "Missing filename");

    return <>{renderSimpleChangeInfo({ from: item.filename.from, to: item.filename.to, label: "Filename:" })}</>;
};
